import React from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

const Header = (props) => {
  const navigate = useNavigate();
  
  return (
    <>
      <div className="student_response_header">
        <div>
          <h3>{props?.title}</h3>
        </div>
        <div className={props.isPrint?'d-none':'d-flex justify-content-between'} style={{ width: '330px' }}>
          <button id="back_button" onClick={() => navigate(-1)} className="btn btn-width btn-castleWhite">
            Back
          </button>
          <button onClick={props?.exportHandler} id="export_button" className="btn btn-width btn-castleOrange" disabled="disabled">
            Export
          </button>
          <button onClick={props?.handlePrint} id="print_button" className="btn btn-castleRed">
            Print to PDF
          </button>
        </div>
      </div>
      <div className="student_response_details">
        <div className="d-flex justify-content-between">
          <div className="student_response_details_left">
            <p>
              Assignment: <strong>{props?.assignmentName}</strong>
            </p>
            <p>
              Course: <strong>{props?.course}</strong>
            </p>
          </div>
          <div className="student_response_details_right">
            <p>
              School: <strong>{props?.schoolName}</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  exportHandler: PropTypes.func,
  handlePrint: PropTypes.func,
  assignmentName: PropTypes.string,
  course: PropTypes.string,
  schoolName: PropTypes.string,
  isPrint: PropTypes.bool
};

export default Header;
